import { type ReactNode } from 'react';

/** Narrow context strip between the hero and features grid. */
export function ContextNote({ text }: { text: ReactNode }) {
    return (
        <section className="mktg-context">
            <div className="mktg-container">
                <p className="mktg-context__note">{text}</p>
            </div>
        </section>
    );
}
